const initialState = {
  loading: true,
}

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_LOADER':
      return {
        ...state,
        loading: action.payload,
      }
    default:
      return state
  }
}

export default userReducer
